import { getWrapper, wrapper } from '../request';
export var getDocDetail = getWrapper('docs')('getDocDetail');
export var getAllDoc = getWrapper('docs')('getAllDoc');
export var updateDoc = wrapper('docs')('updateDoc');